export const REGISTER_PROFILE = '/register_profile';
export const PROFILE = '/profile';
export const PUBLISH_SETTING = '/publish_setting';
export const ACCOUNT_SETTING = '/account_setting';
export const MESSAGES = '/messages';
